export const themes = [
  {
    name: "Default",
    value: "default",
    sidebarBackground: "",
    channelBackground: "",
    activeItem: "",
    activeItemText: "",
    hoverItem: "",
    textColor: "",
    activePresence: "",
    mentionBadge: "",
    // borderWidth: "",
    // borderColor: "",
    // borderRadius: "",
  },
  {
    name: "Dark",
    value: "dark",
    sidebarBackground: "",
    channelBackground: "",
    activeItem: "",
    activeItemText: "",
    hoverItem: "",
    textColor: "",
    activePresence: "",
    mentionBadge: "",
  },
  {
    name: "Light",
    value: "light",
    sidebarBackground: "",
    channelBackground: "",
    activeItem: "",
    activeItemText: "",
    hoverItem: "",
    textColor: "",
    activePresence: "",
    mentionBadge: "",
  },
  {
    name: "360Channel",
    value: "360channel",
    sidebarBackground: "#323232",
    channelBackground: "#E60A00",
    activeItem: "#E60A00",
    activeItemText: "#FFFFFF",
    hoverItem: "#505050",
    textColor: "#F5F5F5",
    activePresence: "#E64600",
    mentionBadge: "#E60A00",
  },
  {
    name: "Afterglow",
    value: "afterglow",
    sidebarBackground: "#2F2C2F",
    channelBackground: "#252525",
    activeItem: "#A36B31",
    activeItemText: "#D2D6D6",
    hoverItem: "#5C6380",
    textColor: "#DEDEDE",
    activePresence: "#ADBA4E",
    mentionBadge: "#DEDEDE",
  },
  {
    name: "AmigaOS1.3",
    value: "amigaos13",
    sidebarBackground: "#0050A0",
    channelBackground: "#000020",
    activeItem: "#F08000",
    activeItemText: "#FFFFFF",
    hoverItem: "#F08000",
    textColor: "#FFFFFF",
    activePresence: "#F08000",
    mentionBadge: "#F08000",
  },
  {
    name: "Ancestry",
    value: "ancestry",
    sidebarBackground: "#534d46",
    channelBackground: "#706b63",
    activeItem: "#7a9c0f",
    activeItemText: "#FFFFFF",
    hoverItem: "#648200",
    textColor: "#FFFFFF",
    activePresence: "#9cbe30",
    mentionBadge: "#f3b670",
  },
  {
    name: "Arc",
    value: "arc",
    sidebarBackground: "#373D48",
    channelBackground: "#303641",
    activeItem: "#5294E2",
    activeItemText: "#FFFFFF",
    hoverItem: "#4A5664",
    textColor: "#FFFFFF",
    activePresence: "#5294E2",
    mentionBadge: "#5294E2",
  },
  {
    name: "Arc Grey",
    value: "arcgrey",
    sidebarBackground: "#383838",
    channelBackground: "#303641",
    activeItem: "#999999",
    activeItemText: "#FFFFFF",
    hoverItem: "#5c5c5c",
    textColor: "#FFFFFF",
    activePresence: "#999999",
    mentionBadge: "#999999",
  },
  {
    name: "Atom One Dark",
    value: "atom-one-dark",
    sidebarBackground: "#121417",
    channelBackground: "#2F343D",
    activeItem: "#2F343D",
    activeItemText: "#ABB2BF",
    hoverItem: "#2F343D",
    textColor: "#ABB2BF",
    activePresence: "#98C379",
    mentionBadge: "#98C379",
  },
  {
    name: "Arizona State University",
    value: "arizona-state-university",
    sidebarBackground: "#8C1D40",
    channelBackground: "#5C6670",
    activeItem: "#FFC627",
    activeItemText: "#FFFFFF",
    hoverItem: "#5C6670",
    textColor: "#FFFFFF",
    activePresence: "#FFFFFF",
    mentionBadge: "#94E864",
  },
  {
    name: "Aubergine",
    value: "aubergine",
    sidebarBackground: "#3F0E40",
    channelBackground: "#350d36",
    activeItem: "#1164A3",
    activeItemText: "#FFFFFF",
    hoverItem: "#350d36",
    textColor: "#FFFFFF",
    activePresence: "#2BAC76",
    mentionBadge: "#CD2553",
  },
  {
    name: "Autumn",
    value: "autumn",
    sidebarBackground: "#194234",
    channelBackground: "#9c2e33",
    activeItem: "#E7C12e",
    activeItemText: "#194234",
    hoverItem: "#9c2e33",
    textColor: "#FFFFFF",
    activePresence: "#ee6030",
    mentionBadge: "#9C2E33",
  },
  {
    name: "AWA",
    value: "awa",
    sidebarBackground: "#222222",
    channelBackground: "#333333",
    activeItem: "#444444",
    activeItemText: "#FFFFFF",
    hoverItem: "#333333",
    textColor: "#FFFFFF",
    activePresence: "#38978D",
    mentionBadge: "#fc7459",
  },
  {
    name: "B-MIND",
    value: "b-mind",
    sidebarBackground: "#1d1d1d",
    channelBackground: "#000000",
    activeItem: "#0ba8ca",
    activeItemText: "#FFFFFF",
    hoverItem: "#075566",
    textColor: "#FFFFFF",
    activePresence: "#0ba8ca",
    mentionBadge: "#EB4D5C",
  },
  {
    name: "Base16 Default Dark",
    value: "base16-default-dark",
    sidebarBackground: "#181818",
    channelBackground: "#585858",
    activeItem: "#7cafc2",
    activeItemText: "#f8f8f8",
    hoverItem: "#b8b8b8",
    textColor: "#f8f8f8",
    activePresence: "#f7ca88",
    mentionBadge: "#ab4642",
  },
  {
    name: "Base16 Eighties Dark",
    value: "base16-eighties-dark",
    sidebarBackground: "#393939",
    channelBackground: "#2D2D2D",
    activeItem: "#F2777A",
    activeItemText: "#FFFFFF",
    hoverItem: "#515151",
    textColor: "#D3D0C8",
    activePresence: "#99CC99",
    mentionBadge: "#66CCCC",
  },
  {
    name: "Base16 Eighties Light",
    value: "base16-eighties-light",
    sidebarBackground: "#F2F0EC",
    channelBackground: "#E8E6DF",
    activeItem: "#F2777A",
    activeItemText: "#FFFFFF",
    hoverItem: "#B8B8B8",
    textColor: "#515151",
    activePresence: "#99CC99",
    mentionBadge: "#66CCCC",
  },
  {
    name: "Base16 Ocean Dark",
    value: "base16-ocean-dark",
    sidebarBackground: "#2b303b",
    channelBackground: "#16181f",
    activeItem: "#4f5b66",
    activeItemText: "#c0c5ce",
    hoverItem: "#343d46",
    textColor: "#a7adba",
    activePresence: "#a3be8c",
    mentionBadge: "#bf616a",
  },
  {
    name: "Base16 Tomorrow Night",
    value: "base16-tomorrow-night",
    sidebarBackground: "#191A1C",
    channelBackground: "#282A2E",
    activeItem: "#B6BC68",
    activeItemText: "#FFFFFF",
    hoverItem: "#363B41",
    textColor: "#959896",
    activePresence: "#80A2BE",
    mentionBadge: "#C26161",
  },
  {
    name: "BCIT",
    value: "bcit",
    sidebarBackground: "#C26161",
    channelBackground: "#000a52",
    activeItem: "#000a52",
    activeItemText: "#000a52",
    hoverItem: "#D37C71",
    textColor: "#FFFFFF",
    activePresence: "#F79F66",
    mentionBadge: "#F15340",
  },
  {
    name: "Beaver Builders",
    value: "beaver-builders",
    sidebarBackground: "#F7941E",
    channelBackground: "#FFB963",
    activeItem: "#FFB963",
    activeItemText: "#110000",
    hoverItem: "#F5A849",
    textColor: "#110000",
    activePresence: "#3D0000",
    mentionBadge: "#507DAA",
  },
  {
    name: "beNext",
    value: "be-next",
    sidebarBackground: "#E3E6EA",
    channelBackground: "#EDEFF1",
    activeItem: "#D1571C",
    activeItemText: "#FFFFFF",
    hoverItem: "#1DB3C5",
    textColor: "#333232",
    activePresence: "#48B8AD",
    mentionBadge: "#D3561A",
  },
  {
    name: "Big Red",
    value: "Bolket",
    sidebarBackground: "#754242",
    channelBackground: "#BD3737",
    activeItem: "#9C4444",
    activeItemText: "#FFFFFF",
    hoverItem: "#434745",
    textColor: "#FFFFFF",
    activePresence: "#99D04A",
    mentionBadge: "#DB6668",
  },
  {
    name: "Bolket",
    value: "bolket",
    sidebarBackground: "#020623",
    channelBackground: "#020623",
    activeItem: "#00B993",
    activeItemText: "#FFFFFF",
    hoverItem: "#41465c",
    textColor: "#FFFFFF",
    activePresence: "#52eb7b",
    mentionBadge: "#FF2154",
  },
  {
    name: "Bourbon",
    value: "bourbon",
    sidebarBackground: "#CF7C44",
    channelBackground: "#CF7C44",
    activeItem: "#E89A6B",
    activeItemText: "#F7DB72",
    hoverItem: "#FBEDD4",
    textColor: "#FFFAFC",
    activePresence: "#92406A",
    mentionBadge: "#92406A",
  },
  {
    name: "Brinjal",
    value: "brinjal",
    sidebarBackground: "#4F2F4C",
    channelBackground: "#452842",
    activeItem: "#8C5888",
    activeItemText: "#FFFFFF",
    hoverItem: "#3E313C",
    textColor: "#FFFFFF",
    activePresence: "#00FFB7",
    mentionBadge: "#DE4C0D",
  },
  {
    name: "Chargify",
    value: "chargify",
    sidebarBackground: "#2C2C26",
    channelBackground: "#229725",
    activeItem: "#13C217",
    activeItemText: "#FFFFFF",
    hoverItem: "#229725",
    textColor: "#FFFFFF",
    activePresence: "#13C217",
    mentionBadge: "#439AEA",
  },
  {
    name: "charity: water",
    value: "charity-water",
    sidebarBackground: "#f4f5f0",
    channelBackground: "#FFFFFF",
    activeItem: "#efd213",
    activeItemText: "#FFFFFF",
    hoverItem: "#EFD213",
    textColor: "#333232",
    activePresence: "#59c77f",
    mentionBadge: "#fa575d",
  },
  {
    name: "Chicago Cubs",
    value: "chicago-cubs",
    sidebarBackground: "#0E3386",
    channelBackground: "#133a94",
    activeItem: "#D12325",
    activeItemText: "#FFFFFF",
    hoverItem: "#a31a1c",
    textColor: "#FFFFFF",
    activePresence: "#D12325",
    mentionBadge: "#D12325",
  },
  {
    name: "Choco Mint",
    value: "choco-mint",
    sidebarBackground: "#544538",
    channelBackground: "#42362B",
    activeItem: "#5DB09D",
    activeItemText: "#FFFFFF",
    hoverItem: "#4A3C30",
    textColor: "#FFFFFF",
    activePresence: "#FFFFFF",
    mentionBadge: "#5DB09D",
  },
  {
    name: "Christmas",
    value: "christmas",
    sidebarBackground: "#138724",
    channelBackground: "#1B5E48",
    activeItem: "#db2e3f",
    activeItemText: "#FFFFFF",
    hoverItem: "#2D9A48",
    textColor: "#FFFFFF",
    activePresence: "#1B5E48",
    mentionBadge: "#DB2E3F",
  },
  {
    name: "Citrus",
    value: "citrus",
    sidebarBackground: "#507800",
    channelBackground: "#94AF63",
    activeItem: "#FFEA00",
    activeItemText: "#507800",
    hoverItem: "#94AF63",
    textColor: "#FFFFFF",
    activePresence: "#F7FF00",
    mentionBadge: "#FF9900",
  },
  {
    name: "Clemson",
    value: "clemson",
    sidebarBackground: "#e56f43",
    channelBackground: "#ff7a4a",
    activeItem: "#46266D",
    activeItemText: "#FFFFFF",
    hoverItem: "#5f3d99",
    textColor: "#ffffff",
    activePresence: "#46266D",
    mentionBadge: "#46266D",
  },
  {
    name: "Cleveland Browns",
    value: "cleveland-browns",
    sidebarBackground: "#342624",
    channelBackground: "#000000",
    activeItem: "#EC5614",
    activeItemText: "#FFFFFF",
    hoverItem: "#7C7E7C",
    textColor: "#FFFFFF",
    activePresence: "#EC5614",
    mentionBadge: "#EC5614",
  },
  {
    name: "Cobalt2",
    value: "cobalt2",
    sidebarBackground: "#193549",
    channelBackground: "#FFC600",
    activeItem: "#1D425D",
    activeItemText: "#FFFFFF",
    hoverItem: "#0085FF",
    textColor: "#FFFFFF",
    activePresence: "#2CDB00",
    mentionBadge: "#FFC600",
  },
  {
    name: "CobaltNext",
    value: "cobalt-next",
    sidebarBackground: "#1b2b34",
    channelBackground: "#343d46",
    activeItem: "#5fb3b3",
    activeItemText: "#1B2B34",
    hoverItem: "#0b151b",
    textColor: "#FFFFFF",
    activePresence: "#99c794",
    mentionBadge: "#fac863",
  },
  {
    name: "CodeMash",
    value: "code-mash",
    sidebarBackground: "#0c84a9",
    channelBackground: "#f67f01",
    activeItem: "#94C53C",
    activeItemText: "#FFFFFF",
    hoverItem: "#16A1C8",
    textColor: "#FFFFFF",
    activePresence: "#FFFFFF",
    mentionBadge: "#94C53C",
  },
  {
    name: "Contentful",
    value: "contentful",
    sidebarBackground: "#192532",
    channelBackground: "#263545",
    activeItem: "#19cd91",
    activeItemText: "#FFFFFF",
    hoverItem: "#263545",
    textColor: "#FFFFFF",
    activePresence: "#19cd91",
    mentionBadge: "#f05751",
  },
  {
    name: "Convoy",
    value: "convoy",
    sidebarBackground: "#3A3D3F",
    channelBackground: "#3A3D3F",
    activeItem: "#D84315",
    activeItemText: "#FFFFFF",
    hoverItem: "#3A3D3F",
    textColor: "#FFFFFF",
    activePresence: "#48B8AD",
    mentionBadge: "#D84315",
  },
  {
    name: "CraftCMS",
    value: "craft-cms",
    sidebarBackground: "#333F4E",
    channelBackground: "#47525F",
    activeItem: "#DA513D",
    activeItemText: "#FFFFFF",
    hoverItem: "#47525F",
    textColor: "#F8F8F8",
    activePresence: "#DA513D",
    mentionBadge: "#DA513D",
  },
  {
    name: "Dallas Stars",
    value: "dallas-stars",
    sidebarBackground: "#000000",
    channelBackground: "#A7A8AC",
    activeItem: "#016F4A",
    activeItemText: "#FFFFFF",
    hoverItem: "#339E7A",
    textColor: "#FFFFFF",
    activePresence: "#339E7A",
    mentionBadge: "#016F4A",
  },
  {
    name: "Danny Torrence",
    value: "danny-torrence",
    sidebarBackground: "#751C01",
    channelBackground: "#5C1500",
    activeItem: "#FFFFFF",
    activeItemText: "#751C01",
    hoverItem: "#AD2A02",
    textColor: "#FFFFFF",
    activePresence: "#FFFFFF",
    mentionBadge: "#AD2A02",
  },
  {
    name: "Dark Zenburn",
    value: "dark-zenburn",
    sidebarBackground: "#333333",
    channelBackground: "#1E2320",
    activeItem: "#709080",
    activeItemText: "#FFFFFF",
    hoverItem: "#1E2320",
    textColor: "#FFFFFF",
    activePresence: "#F0DFAF",
    mentionBadge: "#CC9393",
  },
  {
    name: "DD",
    value: "dd",
    sidebarBackground: "#222222",
    channelBackground: "#111111",
    activeItem: "#111111",
    activeItemText: "#66AADD",
    hoverItem: "#555555",
    textColor: "#EEEEEE",
    activePresence: "#66DD66",
    mentionBadge: "#DD666D",
  },
  {
    name: "Decred",
    value: "decred",
    sidebarBackground: "#0c1e3e",
    channelBackground: "#153161",
    activeItem: "#2970ff",
    activeItemText: "#FFFFFF",
    hoverItem: "#153161",
    textColor: "#FFFFFF",
    activePresence: "#2ed6a1",
    mentionBadge: "#2ed6a1",
  },
  {
    name: "Deep Blue",
    value: "deep-blue",
    sidebarBackground: "#0074B2",
    channelBackground: "#0083CA",
    activeItem: "#00A2FF",
    activeItemText: "#FFFFFF",
    hoverItem: "#00A5FF",
    textColor: "#FFFFFF",
    activePresence: "#03EEFF",
    mentionBadge: "#00CCC2",
  },
  {
    name: "Deezer",
    value: "deezer",
    sidebarBackground: "#23232c",
    channelBackground: "#42424D",
    activeItem: "#007FEB",
    activeItemText: "#fefefe",
    hoverItem: "#42424d",
    textColor: "#c2c2ca",
    activePresence: "#a4bf36",
    mentionBadge: "#f74343",
  },
  {
    name: "Delta",
    value: "delta",
    sidebarBackground: "#253346",
    channelBackground: "#434f61",
    activeItem: "#434f61",
    activeItemText: "#FFFFFF",
    hoverItem: "#434f61",
    textColor: "#f4f5f7",
    activePresence: "#44DB5E",
    mentionBadge: "#f72951",
  },
  {
    name: "Design Hub",
    value: "design-hub",
    sidebarBackground: "#1B549E",
    channelBackground: "#1B549E",
    activeItem: "#19C0E7",
    activeItemText: "#FFFFFF",
    hoverItem: "#19C0E7",
    textColor: "#FFFFFF",
    activePresence: "#19C0E7",
    mentionBadge: "#FFFFFF",
  },
  {
    name: "devRant",
    value: "devrant",
    sidebarBackground: "#40415a",
    channelBackground: "#54556e",
    activeItem: "#f99a66",
    activeItemText: "#FFFFFF",
    hoverItem: "#54556e",
    textColor: "#FFFFFF",
    activePresence: "#d55161",
    mentionBadge: "#d55161",
  },
  {
    name: "Digital Media Solutions",
    value: "digital-media-solutions",
    sidebarBackground: "#117bcf",
    channelBackground: "#117bcf",
    activeItem: "#467ca2",
    activeItemText: "#FFFFFF",
    hoverItem: "#2E3234",
    textColor: "#FFFFFF",
    activePresence: "#7DB461",
    mentionBadge: "#cb4641",
  },
  {
    name: "DigitalOcean",
    value: "digitalocean",
    sidebarBackground: "#3686BE",
    channelBackground: "#215F8B",
    activeItem: "#7DB461",
    activeItemText: "#FFFFFF",
    hoverItem: "#2E3234",
    textColor: "#FFFFFF",
    activePresence: "#7DB461",
    mentionBadge: "#215F8B",
  },
  {
    name: "Discord",
    value: "discord",
    sidebarBackground: "#2e3136",
    channelBackground: "#282b30",
    activeItem: "#282b30",
    activeItemText: "#ffffff",
    hoverItem: "#282b30",
    textColor: "#818386",
    activePresence: "#43b581",
    mentionBadge: "#7289da",
  },
  {
    name: "Docker",
    value: "docker",
    sidebarBackground: "#0e0e10",
    channelBackground: "#0e0e10",
    activeItem: "#0e0e10",
    activeItemText: "#f1f1f1",
    hoverItem: "#0e0e10",
    textColor: "#f1f1f1",
    activePresence: "#0e0e10",
    mentionBadge: "#0e0e10",
  },
  {
    name: "Dolly Dark",
    value: "dolly-dark",
    sidebarBackground: "#635C5A",
    channelBackground: "#564F4D",
    activeItem: "#E7412A",
    activeItemText: "#FFFFFF",
    hoverItem: "#564F4D",
    textColor: "#FFFFFF",
    activePresence: "#8DA600",
    mentionBadge: "#0EA7B5",
  },
  {
    name: "Dolly Light",
    value: "dolly-light",
    sidebarBackground: "#FAFAFA",
    channelBackground: "#F3F3F3",
    activeItem: "#E7412A",
    activeItemText: "#FFFFFF",
    hoverItem: "#EDEDED",
    textColor: "#564F4D",
    activePresence: "#8DA600",
    mentionBadge: "#0EA7B5",
  },
  {
    name: "Douglas Rain",
    value: "douglas-rain",
    sidebarBackground: "#EDECEB",
    channelBackground: "#E3E3E3",
    activeItem: "#DA552F",
    activeItemText: "#FFFFFF",
    hoverItem: "#D6D6D6",
    textColor: "#534540",
    activePresence: "#DA552F",
    mentionBadge: "#DA552F",
  },
  {
    name: "Draft U.S. Web Design Standards",
    value: "draft-us-web-design-standards",
    sidebarBackground: "#112E51",
    channelBackground: "#205493",
    activeItem: "#0071BC",
    activeItemText: "#FFFFFF",
    hoverItem: "#323A45",
    textColor: "#FFFFFF",
    activePresence: "#4AA564",
    mentionBadge: "#981B1E",
  },
  {
    name: "Dribbble",
    value: "dribbble",
    sidebarBackground: "#E6E6E6",
    channelBackground: "#E6E6E6",
    activeItem: "#E6E6E6",
    activeItemText: "#FFFFFF",
    hoverItem: "#E6E6E6",
    textColor: "#FFFFFF",
    activePresence: "#E6E6E6",
    mentionBadge: "#E6E6E6",
  },
  {
    name: "Dropbox",
    value: "dropbox",
    sidebarBackground: "#007EE5",
    channelBackground: "#007EE5",
    activeItem: "#47525D",
    activeItemText: "#FFFFFF",
    hoverItem: "#7B8994",
    textColor: "#FFFFFF",
    activePresence: "#47525D",
    mentionBadge: "#47525D",
  },
  {
    name: "Drund",
    value: "drund",
    sidebarBackground: "#181818",
    channelBackground: "#202020",
    activeItem: "#99CB3F",
    activeItemText: "#FFFFFF",
    hoverItem: "#202020",
    textColor: "#FFFFFF",
    activePresence: "#99CB3F",
    mentionBadge: "#F7124E",
  },
  {
    name: "Drupal Twig",
    value: "drupal-twig",
    sidebarBackground: "#6fa36f",
    channelBackground: "#3E313C",
    activeItem: "#01690b",
    activeItemText: "#ffff00",
    hoverItem: "#3E313C",
    textColor: "#ffffff",
    activePresence: "#faff78",
    mentionBadge: "#ed687e",
  },
  {
    name: "EGA",
    value: "ega",
    sidebarBackground: "#0000AA",
    channelBackground: "#00AAAA",
    activeItem: "#FF55FF",
    activeItemText: "#FFFFFF",
    hoverItem: "#00AAAA",
    textColor: "#FFFFFF",
    activePresence: "#C0C0C0",
    mentionBadge: "#FF00FF",
  },
  {
    name: "elementary GTK",
    value: "elementary-gtk",
    sidebarBackground: "#dfdfdf",
    channelBackground: "#f5f5f5",
    activeItem: "#cecece",
    activeItemText: "#333333",
    hoverItem: "#f5f5f5",
    textColor: "#333333",
    activePresence: "#93d844",
    mentionBadge: "#da4d45",
  },
  {
    name: "Ember.js",
    value: "ember-js",
    sidebarBackground: "#faf4f1",
    channelBackground: "#faf4f1",
    activeItem: "#E77562",
    activeItemText: "#ffffff",
    hoverItem: "#E5DBD6",
    textColor: "#717171",
    activePresence: "#E46651",
    mentionBadge: "#E46651",
  },
  {
    name: "EMBL",
    value: "embl",
    sidebarBackground: "#389196",
    channelBackground: "#C3C0AB",
    activeItem: "#9FCC3B",
    activeItemText: "#008CB5",
    hoverItem: "#C3C0AB",
    textColor: "#FFFFFF",
    activePresence: "#D90F21",
    mentionBadge: "#D90f21",
  },
  {
    name: "Facebook",
    value: "facebook",
    sidebarBackground: "#4E69A2",
    channelBackground: "#38528B",
    activeItem: "#38528B",
    activeItemText: "#FFFFFF",
    hoverItem: "#38528B",
    textColor: "#FFFFFF",
    activePresence: "#1FAD38",
    mentionBadge: "#CD2323",
  },
  {
    name: "FC Bayern München",
    value: "fc-bayern-muenchen",
    sidebarBackground: "#B51929",
    channelBackground: "#B51929",
    activeItem: "#23408E",
    activeItemText: "#BCA26F",
    hoverItem: "#025277",
    textColor: "#FFFFFF",
    activePresence: "#E5D3A0",
    mentionBadge: "#B7B6B7",
  },
  {
    name: "Film Noir",
    value: "film-noir",
    sidebarBackground: "#101010",
    channelBackground: "#101010",
    activeItem: "#D3D3CA",
    activeItemText: "#BB313E",
    hoverItem: "#424242",
    textColor: "#F0F0E6",
    activePresence: "#BB313E",
    mentionBadge: "#BB313E",
  },
  //aaaaaaaa
  {
    name: "Ziik.io",
    value: "ziikio",
    sidebarBackground: "#DEE2E6",
    channelBackground: "#ffffff",
    activeItem: "#0279f9",
    activeItemText: "#FFFFFF",
    hoverItem: "#ffffff",
    textColor: "#37393c",
    activePresence: "#0279f9",
    mentionBadge: "#0279F9",
  },
  {
    name: "Kawaii",
    value: "kawaii",
    sidebarBackground: "#FBFBFB",
    channelBackground: "#FBFBFB",
    activeItem: "#F9C6D6",
    activeItemText: "#5D5759",
    hoverItem: "#8EEADB",
    textColor: "#5D5759",
    activePresence: "#F0A2B8",
    mentionBadge: "#F0A2B8",
  },
  {
    name: "frame.ai",
    value: "frameai",
    sidebarBackground: "#39434D",
    channelBackground: "#272e35",
    activeItem: "#F26900",
    activeItemText: "#ffffff",
    hoverItem: "#272E35",
    textColor: "#ADBED1",
    activePresence: "#48B8AD",
    mentionBadge: "#F3B200",
  },
  {
    name: "Trello",
    value: "trello",
    sidebarBackground: "#0079BF",
    channelBackground: "#026AA7",
    activeItem: "#5BA4CF",
    activeItemText: "#FFFFFF",
    hoverItem: "#026AA7",
    textColor: "#FFFFFF",
    activePresence: "#61BD4F",
    mentionBadge: "#EB5A46",
  },
  {
    name: "Dobby Purple",
    value: "dobby-purple",
    sidebarBackground: "#6236ba",
    channelBackground: "#56A656",
    activeItem: "#56a656",
    activeItemText: "#FFFFFF",
    hoverItem: "#56A656",
    textColor: "#ffffff",
    activePresence: "#D0FF00",
    mentionBadge: "#889100",
  },
  {
    name: "Metal Blue",
    value: "metal-blue",
    sidebarBackground: "#36414C",
    channelBackground: "#4D5561",
    activeItem: "#515C6B",
    activeItemText: "#FFFFFF",
    hoverItem: "#4D5561",
    textColor: "#FFFFFF",
    activePresence: "#B3CAF0",
    mentionBadge: "#8097BD",
  },
  {
    name: "WillowTree - Light",
    value: "willowtree-light",
    sidebarBackground: "#f9f9f9",
    channelBackground: "#1BD9C4",
    activeItem: "#1BD9C4",
    activeItemText: "#094074",
    hoverItem: "#1BD9C4",
    textColor: "#308390",
    activePresence: "#1bd9c4",
    mentionBadge: "#DB6668",
  },
  {
    name: "WillowTree - Dark",
    value: "willowtree-dark",
    sidebarBackground: "#308390",
    channelBackground: "#1BD9C4",
    activeItem: "#1BD9C4",
    activeItemText: "#FFFFFF",
    hoverItem: "#40C1BB",
    textColor: "#f0f0f4",
    activePresence: "#1bd9c4",
    mentionBadge: "#DB6668",
  },
  {
    name: "Vegas Golden Knights",
    value: "vegas-golden-knights",
    sidebarBackground: "#333333",
    channelBackground: "#85714D",
    activeItem: "#85714D",
    activeItemText: "#FFFFFF",
    hoverItem: "#85714D",
    textColor: "#FFFFFF",
    activePresence: "#E31837",
    mentionBadge: "#E31837",
  },
  {
    name: "Milligram.io",
    value: "milligramio",
    sidebarBackground: "#F4F5F6",
    channelBackground: "#FFFFFF",
    activeItem: "#9B4DCA",
    activeItemText: "#ffffff",
    hoverItem: "#FFFFFF",
    textColor: "#606c76",
    activePresence: "#9B4DCA",
    mentionBadge: "#9B4DCA",
  },
  {
    name: "Mojave Dark Mode Blue",
    value: "mojave-dark-mode-blue",
    sidebarBackground: "#333336",
    channelBackground: "#2e2e31",
    activeItem: "#666668",
    activeItemText: "#ffffff",
    hoverItem: "#277df6",
    textColor: "#d7d5d4",
    activePresence: "#277df6",
    mentionBadge: "#277df6",
  },
  {
    name: "Youtube",
    value: "youtube",
    sidebarBackground: "#FFFFFF",
    channelBackground: "#CC181E",
    activeItem: "#CC181E",
    activeItemText: "#FFFFFF",
    hoverItem: "#444444",
    textColor: "#0D0D0D",
    activePresence: "#CC181E",
    mentionBadge: "#E04A4D",
  },
  {
    name: "Windows XP",
    value: "windows-xp",
    sidebarBackground: "#F0EDE0",
    channelBackground: "#0054E3",
    activeItem: "#0054E3",
    activeItemText: "#FFFFFF",
    hoverItem: "#0054E3",
    textColor: "#000000",
    activePresence: "#ED6D3A",
    mentionBadge: "#ED6D3A",
  },
  {
    name: "WordPress",
    value: "wordpress",
    sidebarBackground: "#23282d",
    channelBackground: "#191e23",
    activeItem: "#0073AA",
    activeItemText: "#FFFFFF",
    hoverItem: "#111111",
    textColor: "#EEEEEE",
    activePresence: "#46b450",
    mentionBadge: "#D54E21",
  },
  {
    name: "Windows 3.1",
    value: "windows-3-1",
    sidebarBackground: "#FFFFFF",
    channelBackground: "#C0C0C0",
    activeItem: "#001F7E",
    activeItemText: "#FFFFFF",
    hoverItem: "#C0C0C0",
    textColor: "#000000",
    activePresence: "#001F7E",
    mentionBadge: "#C0C0C0",
  },
  {
    name: "Windows 95",
    value: "windows-95",
    sidebarBackground: "#327C7E",
    channelBackground: "#001F7E",
    activeItem: "#001F7E",
    activeItemText: "#FFFFFF",
    hoverItem: "#001F7E",
    textColor: "#FFFFFF",
    activePresence: "#C0C0C0",
    mentionBadge: "#C0C0C0",
  },
  {
    name: "Windows 98",
    value: "windows-98",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Windows 2000",
    value: "windows-2000",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Windows 10",
    value: "windows-10",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Windows 7",
    value: "windows-7",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Windows 8",
    value: "windows-8",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Windows 8.1",
    value: "windows-8-1",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Windows 11",
    value: "windows-11",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Vue.js",
    value: "vuejs",
    sidebarBackground: "#34495E",
    channelBackground: "#42B983",
    activeItem: "#42B983",
    activeItemText: "#FFFFFF",
    hoverItem: "#42B983",
    textColor: "#FFFFFF",
    activePresence: "#FFD41D",
    mentionBadge: "#42B983",
  },
  {
    name: "React",
    value: "react",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Angular",
    value: "angular",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "VsCode",
    value: "vscode",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "GitHub",
    value: "github",
    sidebarBackground: "#ffffff",
    channelBackground: "#24292e",
    activeItem: "#e9f0f7",
    activeItemText: "#1d4880",
    hoverItem: "#ffefc6",
    textColor: "#666666",
    activePresence: "#28a745",
    mentionBadge: "#92979b",
  },
  {
    name: "GitLab",
    value: "gitlab",
    sidebarBackground: "#643685",
    channelBackground: "#634489",
    activeItem: "#FC6D26",
    activeItemText: "#ffffff",
    hoverItem: "#71558f",
    textColor: "#ffffff",
    activePresence: "#FCA326",
    mentionBadge: "#e24329",
  },
  {
    name: "GitHub Activity Graph",
    value: "github-activity-graph",
    sidebarBackground: "#333333",
    channelBackground: "#222222",
    activeItem: "#44A340",
    activeItemText: "#FFFFFF",
    hoverItem: "#8CBE65",
    textColor: "#FFFFFF",
    activePresence: "#D6E685",
    mentionBadge: "#1E6823",
  },
  {
    name: "GitLab Dark",
    value: "gitlab-dark",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "GitHub Light",
    value: "github-light",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "GitLab Light",
    value: "gitlab-light",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Twitter",
    value: "twitter",
    sidebarBackground: "#55ACEE",
    channelBackground: "#55ACEE",
    activeItem: "#E1E8ED",
    activeItemText: "#292F33",
    hoverItem: "#ADDCFF",
    textColor: "#F5F8FA",
    activePresence: "#E1E8ED",
    mentionBadge: "#E1E8ED",
  },
  {
    name: "Twitter Dark",
    value: "twitter-dark",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Google",
    value: "google",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Google Dark",
    value: "google-dark",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Microsoft Edge Chromium",
    value: "microsoft-edge-chromium",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Twitch",
    value: "twitch",
    sidebarBackground: "#7d5bbe",
    channelBackground: "#6441a4",
    activeItem: "#6441a4",
    activeItemText: "#ffffff",
    hoverItem: "#6441a4",
    textColor: "#ffffff",
    activePresence: "#6441a4",
    mentionBadge: "#6441a4",
  },
  {
    name: "Pornhub",
    value: "pornhub",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Cupcake",
    value: "cupcake",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Bumblebee",
    value: "bumblebee",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Emerald",
    value: "emerald",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Corporate",
    value: "corporate",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Synthwave",
    value: "synthwave",
    sidebarBackground: "#2D1B69",
    channelBackground: "#2D1B69",
    activeItem: "#E779C0",
    activeItemText: "#201062",
    hoverItem: "#413178",
    textColor: "#F9F7FD",
    activePresence: "#71EAD2",
    mentionBadge: "#E779C0",
  },
  {
    name: "Retro",
    value: "retro",
    sidebarBackground: "#E4D8B4",
    channelBackground: "#E4D8B4",
    activeItem: "#EF9A95",
    activeItemText: "#000000",
    hoverItem: "#D1C6A6",
    textColor: "#000000",
    activePresence: "#009485",
    mentionBadge: "#EF9A95",
  },
  {
    name: "Cyberpunk",
    value: "cyberpunk",
    sidebarBackground: "#FFEE00",
    channelBackground: "#FFEE00",
    activeItem: "#FF7597",
    activeItemText: "#000000",
    hoverItem: "#e5d600",
    textColor: "#000000",
    activePresence: "#009485",
    mentionBadge: "#FF7597",
  },
  {
    name: "Valentine",
    value: "valentine",
    sidebarBackground: "#F0D6E8",
    channelBackground: "#F0D6E8",
    activeItem: "#E96D7C",
    activeItemText: "#FFFFFF",
    hoverItem: "#E2C4D6",
    textColor: "#632C3B",
    activePresence: "#009485",
    mentionBadge: "#E96D7C",
  },
  {
    name: "Halloween",
    value: "halloween",
    sidebarBackground: "#212121",
    channelBackground: "#212121",
    activeItem: "#F28C18",
    activeItemText: "#000000",
    hoverItem: "#383838",
    textColor: "#FFFFFF",
    activePresence: "#87D039",
    mentionBadge: "#F28C18",
  },
  {
    name: "Garden",
    value: "garden",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Forest",
    value: "forest",
    sidebarBackground: "#E9E7E7",
    channelBackground: "#E9E7E7",
    activeItem: "#5C7F67",
    activeItemText: "#FFFFFF",
    hoverItem: "#D3D1D1",
    textColor: "#000000",
    activePresence: "#009485",
    mentionBadge: "#5C7F67",
  },
  {
    name: "Aqua",
    value: "aqua",
    sidebarBackground: "#0B25B7",
    channelBackground: "#0B25B7",
    activeItem: "#42E3FF",
    activeItemText: "#000084",
    hoverItem: "#243BBE",
    textColor: "#FFFFFF",
    activePresence: "#009485",
    mentionBadge: "#42E3FF",
  },
  {
    name: "Lofi",
    value: "Lofi",
    sidebarBackground: "#FFFFFF",
    channelBackground: "#FFFFFF",
    activeItem: "#808080",
    activeItemText: "#FFFFFF",
    hoverItem: "#F2F2F2",
    textColor: "#7D7D90",
    activePresence: "#009485",
    mentionBadge: "#808080",
  },
  {
    name: "Pastel",
    value: "pastel",
    sidebarBackground: "#FFFFFF",
    channelBackground: "#FFFFFF",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Fantasy",
    value: "fantasy",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Wireframe",
    value: "wireframe",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Black",
    value: "black",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Luxury",
    value: "luxury",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Dracula",
    value: "dracula",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "CMYK",
    value: "cmyk",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Zalo",
    value: "zalo",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Shopee",
    value: "shopee",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "TikTok",
    value: "tiktok",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Skype",
    value: "skype",
    sidebarBackground: "#F0F4F8",
    channelBackground: "#39B1DF",
    activeItem: "#C7EDFC",
    activeItemText: "#000000",
    hoverItem: "#F0F4F8",
    textColor: "#000000",
    activePresence: "#7FBA00",
    mentionBadge: "#FF8C00",
  },
  {
    name: "Slack",
    value: "slack",
    sidebarBackground: "#573D82",
    channelBackground: "#453068",
    activeItem: "#3FBA91",
    activeItemText: "#FFFFFF",
    hoverItem: "#453068",
    textColor: "#FFFFFF",
    activePresence: "#3FBA91",
    mentionBadge: "#FF3E88",
  },
  {
    name: "WhatsApp",
    value: "whatsapp",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Instagram",
    value: "instagram",
    sidebarBackground: "#aaa",
    channelBackground: "#aaa",
    activeItem: "#aaa",
    activeItemText: "#aaa",
    hoverItem: "#aaa",
    textColor: "#aaa",
    activePresence: "#aaa",
    mentionBadge: "#aaa",
  },
  {
    name: "Snapchat",
    value: "snapchat",
    sidebarBackground: "",
    channelBackground: "",
    activeItem: "",
    activeItemText: "",
    hoverItem: "",
    textColor: "",
    activePresence: "",
    mentionBadge: "",
  },
];
//Text-kashida-space:https://htmlcss.fandom.com/wiki/Text-kashida-space
